import React from 'react';
import { QuestionAudio } from '@ovos-media/templates/dist/sp';
import { generateUrl } from '../domains/uploads';

export default ({ file_audio_id, ...props }) => (
  <QuestionAudio
    {...props}
    audioSource={generateUrl(file_audio_id)}
  />
);